import { deserializeQueryParams } from "./network";

export default function getCurrenQueryParams() {
  return deserializeQueryParams(window.location.search);
}